var React = require('react');
var { connect, useSelector } = require('react-redux');
var GraphToggle = require('GraphToggle');
const { useTranslation, withTranslation } = require('react-i18next');
var SensorGraph = require('SensorGraph');
const { useEffect, useState } = require('react');
var GeneralClasses = require('GeneralClasses');
var { unitDisplayName } = require('unitsManager');
var { getWaterInputData, WATER_INPUT_DATA } = require('accumulatedManager');
var $ = require('jquery');
require('./AllFarmView/FieldDetailsWPGraph.css');

const WaterMeterGraphContainer = (props) => {
  const { t } = useTranslation();
  const [waterMeterData, setWaterMeterData] = useState({});
  const [sensor_graph, setSensor_graph] = useState(null);
  const [maxValYAxis, setMaxValYAxis] = useState(0); // this val responsible to determine margin of top-right side menu
  let [waterInputsKeys, setWaterInputsKeys] = useState([...WATER_INPUT_DATA]);
  let userUnits =
    props.userData && 'length' in props.userData
      ? unitDisplayName(props.userData.length)
      : '';
  let dataInLoadingState =
    props.selectedField?.historical_data?.['wfr_length'] ||
    props.selectedField?.historical_data?.['precipitation_h'] ||
    props.selectedField?.historical_data?.['baseline_etc_by_kc_table'] ||
    props.selectedField?.historical_data?.['adaptive_etc_by_kc_opt'];

  let graphTitleColor =
    props.field_state === 'active' ? 'text-grey45' : 'text-grey71';

  useEffect(() => {
    if (typeof dataInLoadingState === 'undefined' || !dataInLoadingState) {
      return;
    }
    const initialKeys = [
      'baseline_etc_by_kc_table',
      'irrigation_precipitation',
    ];
    loadWaterData(initialKeys);
  }, [
    props.selectedField?.historical_data?.['wfr_length'],
    props.selectedField?.historical_data?.['precipitation_h'],
    props.selectedField?.historical_data?.['adaptive_etc_by_kc_opt'],
    props.selectedField?.historical_data?.['baseline_etc_by_kc_table'],
    dataInLoadingState,
  ]);

  useEffect(() => {
    let keys = [...WATER_INPUT_DATA];
    setWaterInputsKeys(keys);
  }, [props.selectedFarmingUnit]);

  useEffect(() => {
    if (sensor_graph) {
      reloadGraph();
    }
  }, [sensor_graph, waterMeterData]);

  const loadWaterData = (waterMeterDataKeys) => {
    if (props?.selectedField) {
      const { newWaterData, maxYAxisVal } = getWaterInputData(
        props.selectedField,
        waterMeterDataKeys,
      );
      setWaterMeterData(newWaterData);
      setMaxValYAxis(maxYAxisVal);
    }
  };

  const reloadGraph = () => {
    let dataToDisplay = {};
    sensor_graph.loadData(null, null, undefined, undefined);
    dataInLoadingState = null;

    if (waterMeterData['baseline_etc_by_kc_table']) {
      dataToDisplay['baseline_etc_by_kc_table'] = new GeneralClasses.Sensor(
        {
          id: t('accumulated_graph_title_baseline_recommendation'),
          name: t('accumulated_graph_title_baseline_recommendation'),
          displayName: t('accumulated_graph_title_baseline_recommendation'),
          data: waterMeterData['baseline_etc_by_kc_table'],
          color: 'var(--color-grey-71)',
          coordinates: { latitude: '23.2222', longitude: '23.2222' },
          settings: { is_active: true },
        },
        t('accumulated_graph_title_baseline_recommendation'),
      );
    }
    if (waterMeterData['irrigation_precipitation']) {
      dataToDisplay['irrigation_precipitation'] = new GeneralClasses.Sensor(
        {
          id: 'Irrigation Precipitation',
          name: 'Irrigation Precipitation',
          displayName: 'Irrigation + Precipitation',
          data: waterMeterData['irrigation_precipitation'],
          color: 'var(--color-additional-active-japonica)',
          coordinates: { latitude: '23.2222', longitude: '23.2222' },
          settings: { is_active: true },
        },
        'Irrigation Precipitation',
      );
    }
    if (waterMeterData['adaptive_etc_by_kc_opt']) {
      dataToDisplay['adaptive_etc_by_kc_opt'] = new GeneralClasses.Sensor(
        {
          id: t('accumulated_graph_title_adaptive_recommendation'),
          name: t('accumulated_graph_title_adaptive_recommendation'),
          displayName: t('accumulated_graph_title_adaptive_recommendation'),
          data: waterMeterData['adaptive_etc_by_kc_opt'],
          color: 'var(--color-additional-active-lilac)',
          coordinates: { latitude: '23.2222', longitude: '23.2222' },
          settings: { is_active: true },
        },
        t('accumulated_graph_title_adaptive_recommendation'),
      );
    }
    if (waterMeterData['wfr']) {
      dataToDisplay['wfr'] = new GeneralClasses.Sensor(
        {
          name: 'Irrigation',
          displayName: 'Irrigation',
          data: waterMeterData['wfr'],
          color: 'var(--color-additional-active-indigo-light)', // original color '#CD91CD',rgb(246,107,122,0.3)
          coordinates: { latitude: '23.2222', longitude: '23.2222' },
          settings: { is_active: true },
        },
        'Irrigation',
      );
    }
    if (waterMeterData['precipitation_h']) {
      dataToDisplay['precipitation_h'] = new GeneralClasses.Sensor(
        {
          id: 'Precipitations',
          name: 'Precipitation',
          displayName: 'Precipitation',
          data: waterMeterData['precipitation_h'],
          color: '#94C7F6',
          coordinates: { latitude: '23.2222', longitude: '23.2222' },
          settings: { is_active: true },
        },
        'Precipitations',
      );
    }
    let temperatureStatistics = {};
    let etcStatistics = {};
    sensor_graph.loadData(
      dataToDisplay,
      props.selectedField?.historical_data,
      0,
      props.selectedField?.geo_data.time_zone,
      temperatureStatistics,
      etcStatistics,
    );
  };

  const onSelectionChanged = (event, waterData) => {
    let waterMeterDataKeys = Object.keys(waterMeterData).filter(
      (key) => waterMeterData[key],
    );
    if (event.target.checked && !waterMeterDataKeys.includes(waterData)) {
      waterMeterDataKeys.push(waterData);
    } else {
      waterMeterDataKeys = waterMeterDataKeys.filter((x) => x !== waterData);
    }
    loadWaterData(waterMeterDataKeys);

    // Track Mixpanel event for graph selection changes
    const graphNameMap = {
      baseline_etc_by_kc_table: 'Baseline Recommendation',
      adaptive_etc_by_kc_opt: 'Adaptive Recommendation',
      irrigation_precipitation: 'Irrigation & Precipitation',
      wfr: 'Irrigation',
      precipitation_h: 'Precipitation',
    };

    const graphName = graphNameMap[waterData] || waterData;
    const status = event.target.checked ? 'on' : 'off';

    mixpanel.track('Accumulated Water Inputs Graph Changed', {
      'Graph Name': graphName,
      Status: status,
    });
  };

  const onSelectAll = (event) => {
    if (event.target.checked) {
      loadWaterData(waterInputsKeys);
    } else {
      loadWaterData([]);
    }
  };

  const isAllSelected = () => {
    for (let waterData in waterInputsKeys) {
      if (!waterMeterData[waterInputsKeys[waterData]]) {
        return false;
      }
    }
    return true;
  };

  // Tooltip IDs (unique per component instance)
  const adaptiveTooltipID = 'addaptiveEtcInfoTooltip';
  const baselineTooltipID = 'baselineEtcInfoTooltip';
  const tooltipContainerID = 'etcInfoTooltipContainer';

  // Inline legend overlay (Baseline / Adaptive / Irrigation+Precipitation
  // / Irrigation / Precipitation). Rendered inside the chart frame so
  // it floats over the chart's plot area instead of above the frame.
  const inlineLegend = (
    <div
      className='position-absolute text-grey45 accumulatedAbsoluteMenu'
      style={{
        zIndex: '1',
        border: '1px solid var(--color-grey-91)',
        borderRadius: '5px',
        backgroundColor: 'var(--color-grey-100)',
        // Position relative to the chart wrapper (`.field-details-wp__chart`,
        // which is `position: relative`).
        top: '32px',
        left:
          maxValYAxis >= 10000
            ? '88px'
            : maxValYAxis >= 1000
              ? '86px'
              : maxValYAxis >= 100
                ? '82px'
                : '78px',
        fontSize: '14px',
        padding: '0px 16px 4px 16px',
        boxSizing: 'border-box',
        boxShadow:
          '0px 2px 2px rgba(146, 158, 181, 0.1), 0px 0px 6px rgba(145, 157, 180, 0.11)',
      }}
    >
      {waterMeterData['baseline_etc_by_kc_table'] && (
        <div
          className='d-flex align-items-center'
          style={{ marginTop: '8px', marginBottom: '4px', gap: '8px' }}
        >
          <div
            className='bg-grey71'
            style={{
              width: 16,
              height: 16,
              borderRadius: 3,
              flexShrink: 0,
            }}
          />
          <span
            className='text-size-14 text-grey45'
            style={{ lineHeight: '16px' }}
          >
            {t('accumulated_graph_title_baseline_recommendation')}
          </span>
          <img
            data-toggle='tooltip'
            id={baselineTooltipID}
            data-container={`#${tooltipContainerID}`}
            onMouseOver={() => {
              $(`#${baselineTooltipID}`).tooltip('show');
            }}
            data-placement='right'
            title={t(
              'accumulated_graph_baseline_recommendation_more_info_description',
            )}
            className='info-icon-custom'
            src={require('images/icons/info_icon.svg')}
            style={{
              width: '14px',
              height: '14px',
              borderRadius: '24px',
              cursor: 'pointer',
              flexShrink: 0,
            }}
          />
        </div>
      )}
      {waterMeterData['adaptive_etc_by_kc_opt'] && (
        <div
          className='d-flex align-items-center'
          style={{ marginTop: '8px', marginBottom: '4px', gap: '8px' }}
        >
          <div
            style={{
              width: 16,
              height: 16,
              borderRadius: 3,
              backgroundColor: 'var(--color-additional-active-lilac)',
              flexShrink: 0,
            }}
          />
          <span
            className='text-size-14 text-grey45'
            style={{ lineHeight: '16px' }}
          >
            {t('accumulated_graph_title_adaptive_recommendation')}
          </span>
          <img
            data-toggle='tooltip'
            id={adaptiveTooltipID}
            data-container={`#${tooltipContainerID}`}
            onMouseOver={() => {
              $(`#${adaptiveTooltipID}`).tooltip('show');
            }}
            data-placement='right'
            title={t(
              'accumulated_graph_adaptive_recommendation_more_info_description',
            )}
            className='info-icon-custom'
            src={require('images/icons/info_icon.svg')}
            style={{
              width: '14px',
              height: '14px',
              borderRadius: '24px',
              cursor: 'pointer',
              flexShrink: 0,
            }}
          />
        </div>
      )}
      {waterMeterData['irrigation_precipitation'] && (
        <div
          className='d-flex align-items-center'
          style={{ marginTop: '8px', marginBottom: '4px', gap: '8px' }}
        >
          <div
            className='bg-japonica'
            style={{
              width: 16,
              height: 16,
              borderRadius: 3,
              flexShrink: 0,
            }}
          />
          <span
            className='text-size-14 text-grey45'
            style={{ lineHeight: '16px' }}
          >
            {t('irrigation') + ' + ' + t('precipitation')}
          </span>
        </div>
      )}

      {waterMeterData['wfr'] && (
        <div
          className='d-flex align-items-center'
          style={{ marginTop: '8px', marginBottom: '4px', gap: '8px' }}
        >
          <div
            style={{
              width: 16,
              height: 16,
              borderRadius: 3,
              flexShrink: 0,
              backgroundColor: 'var(--color-additional-active-indigo-light)',
            }}
          />
          <span
            className='text-size-14 text-grey45'
            style={{ lineHeight: '16px' }}
          >
            {t('irrigation')}
          </span>
        </div>
      )}
      {waterMeterData['precipitation_h'] && (
        <div
          className='d-flex align-items-center'
          style={{ marginTop: '8px', marginBottom: '4px', gap: '8px' }}
        >
          <div
            className='bg-blue-third'
            style={{
              width: 16,
              height: 16,
              borderRadius: 3,
              flexShrink: 0,
            }}
          />
          <span
            className='text-size-14 text-grey45'
            style={{ lineHeight: '16px' }}
          >
            {t('precipitation')}
          </span>
        </div>
      )}
    </div>
  );

  return (
    <div className='field-details-wp field-details-wp--fluid field-details-wp--accumulated'>
      <div id={tooltipContainerID}></div>
      <div className='field-details-wp__header'>
        <div className='field-details-wp__title-group'>
          <div className='field-details-wp__toggle'>
            <GraphToggle
              initialValue='accumulated'
              onToggleClick={(toggle) => props.onToggleClick(toggle)}
              icon={props.icon}
              temperatureUnit={props.temperatureUnit}
            />
          </div>
          <span
            className={'field-details-wp__title ' + graphTitleColor}
            style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
          >
            {t('accumulated_water_input')}
            {!dataInLoadingState && (
              <span
                className='spinner-border text-grey45'
                role='status'
                style={{ width: '15px', height: '15px' }}
              />
            )}
          </span>
        </div>

        <div
          className={'dropdown text-size-16 text-grey71 align-self-center'}
          // Match the .field-details-wp__title translate so the dropdown
          // sits at the same vertical position as the title.
          // Lift above the chart frame (which has overflow:hidden + a
          // stacking context) so the open menu isn't clipped or hidden.
          style={{
            transform: 'translateY(4px)',
            position: 'relative',
            zIndex: 10,
          }}
        >
          <div
            className='dropdown-toggle'
            data-toggle='dropdown'
            aria-haspopup='true'
            aria-expanded='false'
            style={{ cursor: 'pointer' }}
          >
            {t('select_graphs')}
          </div>
          <div
            className='dropdown-menu p-1 pb-0 pt-2 dropdown-menu-right'
            aria-labelledby='dropdownMenuButton'
            style={{
              boxShadow:
                '0px 6px 15px -2px rgba(0, 0, 0, 0.07), 0px 3px 10px -2px rgba(0, 0, 0, 0.06)',
            }}
          >
            <div className='mb-2'>
              <div className='d-flex align-items-center '>
                <input
                  className='ml-2'
                  type='checkbox'
                  checked={isAllSelected()}
                  onChange={(element) => {
                    onSelectAll(element);
                  }}
                />
                <span
                  className='text-size-14 text-grey45 font-weight-regular text-truncate pr-2'
                  style={{
                    lineHeight: '20px',
                    padding: '4px 18px 4px 0px',
                    marginLeft: 8,
                    marginRight: 8,
                  }}
                >
                  {t('select_all')}
                </span>
              </div>
              <div
                className='d-flex'
                style={{ justifyContent: 'space-around' }}
              >
                <div
                  className='bg-grey91'
                  style={{ height: 1, width: '90%' }}
                />
              </div>
            </div>

            <div className='d-flex mb-3 align-items-center'>
              <input
                className='ml-2'
                type='checkbox'
                checked={waterMeterData['baseline_etc_by_kc_table'] || false}
                onChange={(element) => {
                  onSelectionChanged(element, 'baseline_etc_by_kc_table');
                }}
              />
              <span
                className='text-size-14 text-white font-weight-semi-bold text-truncate pl-2 pr-2 bg-grey71'
                style={{
                  borderRadius: '3px',
                  lineHeight: '20px',
                  padding: '2px 18px 2px 18px',
                  marginLeft: 8,
                  marginRight: 8,
                }}
              >
                {t('accumulated_graph_title_baseline_recommendation')}
              </span>
            </div>
            <div className='d-flex mb-3 align-items-center'>
              <input
                className='ml-2'
                type='checkbox'
                checked={waterMeterData['adaptive_etc_by_kc_opt'] || false}
                onChange={(element) => {
                  onSelectionChanged(element, 'adaptive_etc_by_kc_opt');
                }}
              />
              <span
                className='text-size-14 text-white font-weight-semi-bold text-truncate pl-2 pr-2'
                style={{
                  borderRadius: '3px',
                  lineHeight: '20px',
                  padding: '2px 18px 2px 18px',
                  marginLeft: 8,
                  marginRight: 8,
                  backgroundColor: 'var(--color-additional-active-lilac)',
                }}
              >
                {t('accumulated_graph_title_adaptive_recommendation')}
              </span>
            </div>

            <div className='d-flex mb-3 align-items-center'>
              <input
                className='ml-2'
                type='checkbox'
                checked={waterMeterData['irrigation_precipitation'] || false}
                onChange={(element) => {
                  onSelectionChanged(element, 'irrigation_precipitation');
                }}
              />
              <span
                className='text-size-14 text-white font-weight-semi-bold text-truncate pl-2 pr-2 bg-japonica'
                style={{
                  borderRadius: '3px',
                  lineHeight: '20px',
                  padding: '2px 18px 2px 18px',
                  marginLeft: 8,
                  marginRight: 8,
                }}
              >
                {t('irrigation') + ' + ' + t('precipitation')}
              </span>
            </div>

            <div className='d-flex mb-3 align-items-center'>
              <input
                className='ml-2'
                type='checkbox'
                checked={waterMeterData['wfr'] || false}
                onChange={(element) => {
                  onSelectionChanged(element, 'wfr');
                }}
              />
              <span
                className='text-size-14 text-white font-weight-semi-bold text-truncate pl-2 pr-2'
                style={{
                  borderRadius: '3px',
                  lineHeight: '20px',
                  padding: '2px 18px 2px 18px',
                  marginLeft: 8,
                  marginRight: 8,
                  backgroundColor:
                    'var(--color-additional-active-indigo-light)',
                }}
              >
                {t('irrigation')}
              </span>
            </div>

            <div className='d-flex mb-3 align-items-center'>
              <input
                className='ml-2'
                type='checkbox'
                checked={waterMeterData['precipitation_h'] || false}
                onChange={(element) => {
                  onSelectionChanged(element, 'precipitation_h');
                }}
              />
              <span
                className='text-size-14 text-white font-weight-semi-bold text-truncate pl-2 pr-2 bg-blue-third'
                style={{
                  borderRadius: '3px',
                  lineHeight: '20px',
                  padding: '2px 18px 2px 18px',
                  marginLeft: 8,
                  marginRight: 8,
                }}
              >
                {t('precipitation')}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className='field-details-wp__frame'>
        <div className='field-details-wp__chart'>
          {inlineLegend}
          <SensorGraph
            onRef={(ref) => setSensor_graph(ref)}
            onGraphUpdate={this.onGraphUpdate}
            hideNavigationButtons={true}
            units={userUnits}
            isLoading={false}
            shouldDrawBottom={false}
            shouldDrawInputs={false}
            shouldDrawResetButton={true}
            toolTipMode={'index'}
            distributionMode={'linear'}
            alignDatesToDayBoundary={true}
            shouldDisplayZoom={false}
            shouldSpaceData={false}
            shouldDiplayUTC={false}
            shouldScaleGraph={false}
            field_state={props.field_state}
            forceZeroYAxisMin={true}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = function (state) {
  return {
    selectedField: state.distribution_data.selected_entities.field,
    selectedFarmingUnit: state.distribution_data.selected_entities.farming_unit,
    selectedDistribution:
      state.distribution_data.selected_entities.distribution,
    loadHistoryStatus: state.distribution_data.field_load_history,
    userData: state.authentication_data.user_data,
    field_state: state.distribution_data.field_state,
  };
};
const mapDispatchToProps = {};

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(WaterMeterGraphContainer));
